<template>
  <footer class="footer">
    <div class="year-selector">
      <label for="year-dropdown">Select Year:</label>
      <select 
        id="year-dropdown" 
        v-model="selectedYear" 
        class="year-dropdown"
      >
        <option 
          v-for="year in availableYears" 
          :key="year" 
          :value="year"
        >
          {{ year }}
        </option>
      </select>
    </div>
  </footer>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Footer',
  computed: {
    selectedYear: {
      get() {
        return this.$store.state.teamData.selectedYear;
      },
      set(value) {
        this.setYearAndLoadData(parseInt(value));
      }
    },
    availableYears() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let year = 2018; year <= currentYear; year++) {
        years.push(year);
      }
      return years.reverse(); // Show most recent years first
    }
  },
  methods: {
    ...mapActions('teamData', ['setYearAndLoadData'])
  }
};
</script>

<style lang="scss" scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
  padding: 10px 20px;
  text-align: center;
  z-index: 1000;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
}

.year-selector {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  
  label {
    font-weight: 500;
    color: #495057;
    margin: 0;
  }
}

.year-dropdown {
  padding: 5px 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
  color: #495057;
  cursor: pointer;
  
  &:focus {
    outline: none;
    border-color: #42b983;
    box-shadow: 0 0 0 2px rgba(66, 185, 131, 0.25);
  }
  
  &:hover {
    border-color: #42b983;
  }
}

// Add padding to body to prevent content from being hidden behind footer
body {
  padding-bottom: 60px;
}
</style>
